<dx-data-grid id="gridContainer" [dataSource]="dataSource" (onToolbarPreparing)="onToolbarPreparing($event)"
  (onEditorPreparing)="onEditorPreparing($event)" (onExporting)="onExporting($event)">

  <!-- Definición de las columnas -->
  <!--    <dxo-selection mode="multiple" showCheckBoxesMode="always" caption="Seleccionar"></dxo-selection>
 -->

  <dxi-column caption="Empresa" alignment="center">
    <dxi-column dataField="company.companyCode" caption="Código" alignment="center"></dxi-column>
    <dxi-column dataField="company.name" caption="Empresa" alignment="center"> </dxi-column>
  </dxi-column>
  <dxi-column caption="Centro" alignment="center">
    <dxi-column dataField="workplaceCode" caption="Código" alignment="center"> </dxi-column>
    <dxi-column dataField="workplaceName" caption="Centro" alignment="center"> </dxi-column>
  </dxi-column>
  <dxi-column caption="Imputación" alignment="center">
    <dxi-column dataField="imputationCode" caption="Código" alignment="center"> </dxi-column>
    <dxi-column dataField="imputationName" caption="Imputacion" alignment="center"> </dxi-column>
  </dxi-column>
  <dxi-column caption="Trabajador" alignment="center">
    <dxi-column dataField="employeeCode" caption="Código" alignment="center"> </dxi-column>
    <dxi-column caption="Trabajador" [calculateDisplayValue]="calculateWorkerName" alignment="center"></dxi-column>
  </dxi-column>
  <dxi-column dataField="viewedAt" caption="Visto" alignment="center">
  </dxi-column>


  <!-- Templates -->
  <dxi-column caption="" [fixed]="true" [fixedPosition]="'right'">
    <dxi-column *ngIf="!exporting" dataField="IdUsuario" caption=" " [allowFiltering]="false" [allowSorting]="false"
      alignment="center" [allowExporting]="false" cellTemplate="buttonCRUDTemplate"></dxi-column>
  </dxi-column>
  <ng-container *dxTemplate="let data of 'buttonCRUDTemplate'">
    <button rel="tooltip" type="button" class="btn btn-danger btn-action" (click)="onDeleteRelation(data.data)">
      <i class="material-icons">close</i>
    </button>
  </ng-container>

  <dxo-export [enabled]="true" [fileName]="'Listado_Empleados_del_Documento'"></dxo-export>
  <!-- Añadir nuevos -->
  <!-- d-none No se ve, habría que editar listFormEditBase.ts -->
  <div *dxTemplate="let data of 'addNew'">

    <button class="btn btn-primary btn-sm btn-add" (click)="openNew()">
      <i class="material-icons">add</i> <span class="d-none d-sm-inline-block">Nuevo</span>
    </button>

  </div>
</dx-data-grid>